import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import "./createStudentProfile.css";
import { ROUTES, MESSAGE } from '../../constant';
import BaseNavbar from '../commanComponents/navbar/baseNavbar';
import InputField from '../commanComponents/inputField/inputField';
import TextInputField from '../commanComponents/textInputField/textInputField';
import PrimaryButton from '../commanComponents/primaryButton/primaryButton';
import { CreateStudentProfileService } from "../../modules/services/index";
import { loadData, saveJsonData, saveData, clearData } from '../../utils/localStorage';
import { validatePhone, validateEmail, validateNewPassword, validateConfirmPassword } from '../../utils/validations';


const CreateStudentProfile = () => {
    
    const [firstClick, setFirstClick] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const userData = JSON.parse(loadData("user"));

    const loginSchema = z.object({
        first_name: z.string().min(1, { message: MESSAGE.THIS_REQUEIRED_FIELD.replace("{0}", "First Name")}),
        last_name: z.string().min(1, { message: MESSAGE.THIS_REQUEIRED_FIELD.replace("{0}", "Last Name")}),
        phone: z.string().nullable().optional(),
        email: z.string().min(1, { message: MESSAGE.THIS_REQUEIRED_FIELD.replace("{0}", "Email")}).refine((email) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(email)) {
                return true; // It's a valid email
            }
            return false; // Invalid input
        }, MESSAGE.FIELD_INVALID.replace("{0}", "Email")),
        password: z.string().min(1, { message: MESSAGE.THIS_REQUEIRED_FIELD.replace("{0}", "Password") }),
        confirm_password: z.string().min(1, { message: MESSAGE.THIS_REQUEIRED_FIELD.replace("{0}", "Confirm Password") }),
    }).refine((data) => data.password === data.confirm_password, {
        message: MESSAGE.CONFIRM_PASSWORD_INVALID,
        path: ["confirm_password"]
    });
    const { register, handleSubmit, setError, formState: { errors }, setValue } = useForm({
        resolver: zodResolver(loginSchema)
    });

    useEffect(() => {
        if (!userData?.first_name) {
            window.location.pathname = ROUTES.LOGIN;
        }

        setValue("first_name", userData?.first_name);
        setValue("last_name", userData?.last_name);
        setValue("email", userData?.email ? userData?.email : "");
    }, []);

    
    const navigate = useNavigate();

    const handleCreateProfile = (data) => {
        setisLoading(true);
        if (data?.phone === ""){
            data["phone"] = null
        }

        (async () => {
            const responseData = await CreateStudentProfileService(userData.id, data, {});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                userData.email = responseData.data.email;
                userData.phone = responseData.data.phone;
                userData.is_profile_created = true;
                saveJsonData("user", userData);
                setisLoading(false);
                window.location.pathname = ROUTES.DASHBOARD;
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                resetFields();
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();            
    }

    const resetFields = () => {
        setisLoading(false);
    }

    return (
        <>
            <BaseNavbar />
            <div className='container'>
                <div className='row'>
                    <div className='col create-student-profile-main-div'>
                        <div className='create-student-profile-form-div'>
                            <Form onSubmit={handleSubmit(handleCreateProfile)}>
                                <Form.Label className='heading'>
                                    CREATE PROFILE
                                </Form.Label>
                                <Form.Label className='sub-heading'>
                                    Welcome, to FIZ Robotic Solutions!
                                    <br/>Let the FIRE begins!
                                </Form.Label>

                                <div className='row'>
                                    <div className='col-sm'>
                                        <TextInputField
                                            placeholder="First name"
                                            fieldType="text"
                                            errorMessage={errors.first_name?.message}
                                            inputKey="first_name"
                                            formRegister={register}
                                        />
                                    </div>
                                    <div className='col-sm'>
                                        <TextInputField
                                            placeholder="Last Name"
                                            fieldType="text"
                                            errorMessage={errors.last_name?.message}
                                            inputKey="last_name"
                                            formRegister={register}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm'>
                                        <TextInputField
                                            placeholder="Email"
                                            fieldType="text"
                                            errorMessage={errors.email?.message}
                                            inputKey="email"
                                            formRegister={register}
                                        />
                                    </div>
                                    <div className='col-sm'>
                                        <TextInputField
                                            placeholder="Mobile Number"
                                            fieldType="text"
                                            errorMessage={errors.phone?.message}
                                            inputKey="phone"
                                            formRegister={register}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm'>
                                        <TextInputField
                                            placeholder="New Password"
                                            fieldType="password"
                                            errorMessage={errors.password?.message}
                                            inputKey="password"
                                            formRegister={register}
                                        />
                                    </div>
                                    <div className='col-sm'>
                                        <TextInputField
                                            placeholder="Confirm Password"
                                            fieldType="password"
                                            errorMessage={errors.confirm_password?.message}
                                            inputKey="confirm_password"
                                            formRegister={register}
                                        />
                                    </div>
                                </div>
                                <br />

                                <div className='submit-button-div'>
                                    <PrimaryButton
                                        text="Submit"
                                        isLoading={isLoading}
                                        type="submit"
                                        customStyle={{height: "40px"}}
                                    />
                                </div>
                            </Form>
                        </div>
                    </div>
                    <div className='col create-student-profile-main-div'>
                        <div className='create-student-profile-text-div'>
                            The <b>email address</b> and <b>mobile number</b> are required for password reset, web notifications, regular updates,
                            annual reports and many such features that will be added-on in the future updates. The information
                            belongs to the parents, not students.<br/><br/>
                            After completing the details listed above, students will be able to:
                            <br/><br/>
                            <ul>
                                <li>To maintain a record of their daily attendance.</li>
                                <li> To gain access to their FRL's curriculum.</li>
                            </ul>
                            In case of any inconvenience please contact <b>contact@fizrobotics.com</b>.
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CreateStudentProfile;
